import React from 'react'
import styled from 'styled-components'

const IconTwitterStyle = styled.div`
    cursor: pointer;

    :hover {
        svg g {
            fill: var(--accent-color);
        }
    }
`

const IconTwitter = ({ socialLink }) => (
    <a href={socialLink} target="blank">
        <IconTwitterStyle>
            <svg
                width="38px"
                height="38px"
                viewBox="0 0 38 38"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <title>icon-twitter</title>
                <desc>Created with Sketch.</desc>
                <g
                    id="icon-twitter"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <path
                        d="M32.5050254,13.8819422 C32.5266075,14.1839577 32.5266075,14.4860396 32.5266075,14.7880551 C32.5266075,23.999926 25.5152395,34.6141634 12.7004991,34.6141634 C8.75251651,34.6141634 5.08503378,33.4707147 2,31.486032 C2.56093334,31.5507117 3.10021826,31.5722937 3.68273362,31.5722937 C6.94029076,31.5722937 9.93906286,30.4720755 12.3337376,28.59517 C9.27028581,28.530424 6.70302134,26.5240928 5.81849048,23.7626566 C6.2499981,23.8273362 6.68143932,23.8705003 7.13452896,23.8705003 C7.76014196,23.8705003 8.38582137,23.7841722 8.96827032,23.6332309 C5.77539284,22.9859694 3.38065173,20.1814355 3.38065173,16.7943862 L3.38065173,16.7081246 C4.30828022,17.2258939 5.38704927,17.5494914 6.53036516,17.592589 C4.65345975,16.3412966 3.42381577,14.2055398 3.42381577,11.789283 C3.42381577,10.494893 3.7689289,9.30834663 4.37302628,8.27280803 C7.8032396,12.5012241 12.9593506,15.262594 18.7410081,15.5646759 C18.6331644,15.0469066 18.5684184,14.5076216 18.5684184,13.9682703 C18.5684184,10.1281314 21.6750342,7 25.5366887,7 C27.5430198,7 29.3551792,7.84136681 30.6280536,9.20050292 C32.2028771,8.89848743 33.713021,8.31597207 35.0506415,7.5177693 C34.5328058,9.13582326 33.4325875,10.4949594 31.9871897,11.3578418 C33.3894899,11.2069005 34.748626,10.8184905 35.999852,10.2792056 C35.0507743,11.6598573 33.8641615,12.8895013 32.5050254,13.8819422 Z"
                        id="Path"
                        stroke="#EE0202"
                        fillRule="nonzero"
                    ></path>
                </g>
            </svg>
        </IconTwitterStyle>
    </a>
)

export default IconTwitter
